export default __webpack_public_path__ + "static/6-a6721897b1d214bc106fac6114654e14.webp";